// extracted by mini-css-extract-plugin
module.exports = {"label":"TinymceEditorConfig_label__28yV5"};